import { render, staticRenderFns } from "./PageRegion.vue?vue&type=template&id=16ec13e4&scoped=true&"
import script from "./PageRegion.vue?vue&type=script&lang=js&"
export * from "./PageRegion.vue?vue&type=script&lang=js&"
import style0 from "./PageRegion.vue?vue&type=style&index=0&id=16ec13e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ec13e4",
  null
  
)

export default component.exports